// Add 'focused' class on focus and manage 'filled' on blur
document.querySelectorAll( 'input, textarea, select' ).forEach( function ( element ) {
  element.addEventListener( 'focus', function () {
    const formGroup = element.closest( '.form-group' );
    if ( formGroup ) {
      formGroup.classList.add( 'focused' );
    }
  } );

  element.addEventListener( 'blur', function () {
    const formGroup = element.closest( '.form-group' );
    if ( element.value.trim() === '' ) {
      element.classList.remove( 'filled' );
      if ( formGroup ) {
        formGroup.classList.remove( 'focused' );
      }
    } else {
      element.classList.add( 'filled' );
      if ( formGroup ) {
        formGroup.classList.add( 'focused' );
      }
    }
  } );

  // Initial state check (for pre-filled fields)
  if ( element.value.trim() !== '' ) {
    element.classList.add( 'filled' );
    const formGroup = element.closest( '.form-group' );
    if ( formGroup ) {
      formGroup.classList.add( 'focused' );
    }
  }
} );

// Add 'form-label' class to all <label> elements
document.querySelectorAll( 'label' ).forEach( function ( label ) {
  label.classList.add( 'form-label' );
} );
